import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import Layout from "@/components/Layout";

/**
 * Renders authenticated users inside the full ZFD shell (sidebar + chat widget),
 * and renders guests inside a minimal "public" shell (logo + sign-in CTA).
 * Used only for routes that are public-readable (currently /wall).
 */
export default function PublicShell({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0F2042] text-white/55 text-sm">
        Loading…
      </div>
    );
  }
  if (user) return <Layout>{children}</Layout>;

  return (
    <div className="min-h-screen bg-[#0F2042] text-white" data-testid="public-shell">
      <header className="sticky top-0 z-30 backdrop-blur-xl bg-[#0F2042]/85 border-b border-white/10">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-3 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <span className="font-display text-[#FBBF24] tracking-[0.18em] text-xs">ZENITH FLOW</span>
            <span className="font-display font-black tracking-tight">DYNAMICS</span>
          </Link>
          <div className="flex items-center gap-2">
            <Link to="/login" className="text-xs uppercase tracking-widest font-bold bg-[#FBBF24] text-[#0F2042] px-3 py-2 rounded-md hover:bg-yellow-300" data-testid="public-shell-login">Sign In</Link>
            <Link to="/register" className="text-xs uppercase tracking-widest font-bold border border-white/15 text-white px-3 py-2 rounded-md hover:bg-white/5" data-testid="public-shell-register">Join ZFD</Link>
          </div>
        </div>
      </header>
      <main className="px-5 md:px-10 py-8 max-w-[1400px] mx-auto">
        {children}
      </main>
    </div>
  );
}
